import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const BrandAssets = dynamic(() => import('ui/pages/BrandAssets'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/brand-assets">
      <BrandAssets/>
    </PageNextJs>
  );
};

export default Page;
